import React, { useEffect, useState } from 'react';
import {
    Table,
    Space,
    Button,
    Avatar,
    Tag,
    Popconfirm,
    Modal,
    Alert,
    Form,
    Input, Grid,
    Upload, message,
    Dropdown, Menu, Select,
    Typography,
    List,
    Card
} from 'antd';
import {

    UsergroupAddOutlined, EllipsisOutlined, MessageOutlined, DeleteOutlined, EditOutlined
} from '@ant-design/icons';
import axios from 'axios';
import { DownloadOutlined } from '@ant-design/icons';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import ActualizarClientes from '../components/ActualizarClientes';

const { useBreakpoint } = Grid;
const { Search } = Input;
const { Option } = Select;
const { Title } = Typography;

const Clientes = () => {
      const screens = useBreakpoint();
    const isMobile = !screens.md; // md = 768px
    const [successMessage, setSuccessMessage] = useState(null);


    const [clientes, setClientes] = useState([]);
    const [clientesFiltrados, setClientesFiltrados] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState('');

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [clienteEditando, setClienteEditando] = useState(null);

    const [dropdownVisible, setDropdownVisible] = useState(false);
  

    const eliminarCliente = async (id) => {
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`https://elarigestion-production.up.railway.app/api/cliente/${id}`, {
                headers: { Authorization: token },
            });
            setSuccessMessage('Cliente eliminado exitosamente');
            fetchClientes();
        } catch (error) {
            Modal.error({
                title: 'Error al eliminar cliente',
                content: error.message,
            });
        }
    };

    const handleMenuClick = (e) => {
        // Aquí puedes decidir si quieres cerrar el menú o no
        if (e.key === 'limpiar' || e.key === 'excel') {
            // Si quieres que se cierre, cierra el menú
            setDropdownVisible(false);
        } else {
            // Si quieres que no se cierre, no hagas nada o mantén abierto
        }
    };

    const handleVisibleChange = (flag) => {
        setDropdownVisible(flag);
    };
    useEffect(() => {
        fetchClientes();
    }, []);

    const fetchClientes = async () => {
        const token = localStorage.getItem('token');
        try {
            const res = await axios.get('https://elarigestion-production.up.railway.app/api/mis-clientes', {
                headers: { Authorization: token },
            });
            setClientes(res.data);
            setClientesFiltrados(res.data);
        } catch (error) {
            Modal.error({
                title: 'Error al cargar los clientes',
                content: error.message,
            });
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (value) => {
        setSearchText(value.toLowerCase());
        const filtered = clientes.filter((cliente) =>
            cliente.nombre_completo?.toLowerCase().includes(value) ||
            cliente.correo_electronico?.toLowerCase().includes(value) ||
            cliente.celular?.toLowerCase().includes(value) ||
            cliente.ciudad?.toLowerCase().includes(value) ||
            cliente.provincia?.toLowerCase().includes(value) ||
            cliente.direccion?.toLowerCase().includes(value)


        );
        setClientesFiltrados(filtered);
    };


    const columns = [
        {
            title: 'Foto',
            dataIndex: 'avatar',
            key: 'avatar',
            render: (avatar, record) =>
                avatar ? (
                    <Avatar src={avatar} alt="avatar" />
                ) : (
                    <Avatar style={{ backgroundColor: record.color_del_fondo }}>
                        {record.nombre_completo
                            ? record.nombre_completo.charAt(0).toUpperCase()
                            : '-'}
                    </Avatar>
                ),
        },



        {
            title: 'Nombre Completo',
            dataIndex: 'nombre_completo',
            key: 'nombre_completo',
            sorter: (a, b) => a.nombre_completo.localeCompare(b.nombre_completo),
        },
        {
            title: 'Correo Electrónico',
            dataIndex: 'correo_electronico',
            key: 'correo_electronico',
            sorter: (a, b) => a.correo_electronico.localeCompare(b.correo_electronico),
        },
        {
            title: 'Celular',
            dataIndex: 'celular',
            key: 'celular',
            sorter: (a, b) => a.celular.localeCompare(b.celular),
        },
        /*    {
               title: 'Ciudad',
               dataIndex: 'ciudad',
               key: 'ciudad',
               render: (text) => text || '-', // Muestra "-" si el valor es null o undefined
           },
   
           {
               title: 'Provincia',
               dataIndex: 'provincia',
               key: 'provincia',
               render: (text) => text || '-', // Muestra "-" si el valor es null o undefined
   
           },
   
           {
               title: 'Dirección',
               dataIndex: 'direccion',
               key: 'direccion',
               render: (text) => text || '-', // Muestra "-" si el valor es null o undefined
   
           }, */


        {
            title: 'Acciones',
            key: 'acciones',
            render: (_, record) => {
                const numero = record.celular.replace(/\D/g, '');

                return (
                    <Space>

                        <a
                            href={`https://wa.me/54${numero}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <MessageOutlined style={{ fontSize: '18px', color: '#25D366' }} />
                        </a>


                        <EditOutlined
                            style={{ fontSize: '18px', color: '#1890ff', cursor: 'pointer' }}
                            onClick={() => {
                                setClienteEditando(record);
                                setIsModalVisible(true);
                            }}
                        />

                        <Popconfirm
                            title="¿Seguro que quieres eliminar este cliente?"
                            onConfirm={() => eliminarCliente(record.id)}
                            okText="Sí"
                            cancelText="No"
                        >
                            <DeleteOutlined style={{ fontSize: '18px', color: 'red', cursor: 'pointer' }} />
                        </Popconfirm>
                    </Space>
                );
            },
        }




    ];
    // Función para exportar Excel
    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Clientes');

        // Encabezados personalizados
        const headers = [
            { header: 'Nombre Completo', key: 'nombre_completo', width: 30 },
            { header: 'Correo Electrónico', key: 'correo_electronico', width: 40 },
            { header: 'Celular', key: 'celular', width: 30 },
            { header: 'Ciudad', key: 'ciudad', width: 30 },
            { header: 'Provincia', key: 'provincia', width: 30 },
            { header: 'Dirección', key: 'direccion', width: 30 },
            { header: 'Codigo', key: 'codigo', width: 30 },

        ];

        worksheet.columns = headers;

        // Agregar los datos
        clientesFiltrados.forEach(cliente => {
            worksheet.addRow({
                nombre_completo: cliente.nombre_completo || '',
                correo_electronico: cliente.correo_electronico || '',
                celular: cliente.celular || '',
                ciudad: cliente.ciudad || '-',
                provincia: cliente.provincia || '-',
                direccion: cliente.direccion || '-',
                codigo: cliente.codigo || '-',

            });
        });
        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber !== 1) {
                row.eachCell(cell => {
                    cell.alignment = {
                        vertical: 'middle',
                        horizontal: 'left',
                        indent: 1,
                    };
                });
            }
        });

        // Estilizar encabezados
        worksheet.getRow(1).eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '000000' }, // negro
            };
            cell.font = {
                color: { argb: 'FFFFFF' }, // blanco
                bold: true,
            };
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
        });

        // Exportar como archivo
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Mis-Clientes.xlsx');
    };

    const mobileMenu = (
        <Menu onClick={handleMenuClick}>

            <Menu.Item key="excel">
                <Button
                    type="primary"
                    onClick={exportToExcel}
                    icon={<DownloadOutlined />}
                    block
                >
                    Exportar Excel
                </Button>
            </Menu.Item>
        </Menu>
    );

    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'row' : '',
                    alignItems: isMobile ? 'flex-start' : 'center',
                    justifyContent: 'space-between',
                    gap: '1rem',
                    marginBottom: 24,
                    padding: isMobile ? '20px' : 0,

                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <UsergroupAddOutlined style={{ fontSize: 28, color: '#1890ff' }} />
                    <Title level={3} style={{ margin: 0 }}>Gestión de Clientes</Title>
                </div>
                <Dropdown overlay={mobileMenu} trigger={['click']} visible={dropdownVisible}
                    onVisibleChange={handleVisibleChange}>
                    <Button icon={<EllipsisOutlined />} />
                </Dropdown>

            </div>

            <div style={{ marginBottom: 16 }}>


                <Search
                    placeholder="Buscar por nombre, correo, provincia o ciudad"
                    allowClear
                    enterButton="Buscar"
                    size="large"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onSearch={handleSearch}
                    style={{
                        width: '100%',
                        maxWidth: '600px',
                        display: 'block',
                        padding: '0 10px',
                        boxSizing: 'border-box',
                    }}
                />
            </div>

            {isMobile ? (
                <List
                    dataSource={clientesFiltrados}
                    loading={loading}
                    renderItem={item => (
                        <Card
                            style={{ marginBottom: 16 }}
                            title={item.nombre_completo}
                            extra={
                                <a href={`https://wa.me/54${item.celular.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer">
                                    <MessageOutlined style={{ color: '#25D366' }} />
                                </a>
                            }
                        >
                            <p><strong>Correo:</strong> {item.correo_electronico}</p>
                            <p><strong>Celular:</strong> {item.celular}</p>
                            <div style={{ display: 'flex', gap: 16 }}>
                                <EditOutlined
                                    style={{ fontSize: 18, color: '#1890ff', cursor: 'pointer' }}
                                    onClick={() => {
                                        setClienteEditando(item);
                                        setIsModalVisible(true);
                                    }}
                                />
                                <Popconfirm
                                    title="¿Seguro que quieres eliminar este cliente?"
                                    onConfirm={() => eliminarCliente(item.id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <DeleteOutlined style={{ fontSize: 18, color: 'red', cursor: 'pointer' }} />
                                </Popconfirm>
                            </div>
                        </Card>
                    )}
                />
            ) : (
                <Table
                    dataSource={clientesFiltrados}
                    columns={columns}
                    rowKey="codigo"
                    loading={loading}
                    pagination={{ pageSize: 10 }}
                    scroll={{ x: 'max-content' }}
                />
            )}

            <Modal
                title="Editar Cliente"
                visible={isModalVisible}
                onCancel={() => {
                    setIsModalVisible(false);
                    setClienteEditando(null);
                }}
                footer={null}
            >
                <ActualizarClientes clienteEditando={clienteEditando} fetchClientes={fetchClientes} setIsModalVisible={setIsModalVisible} />
            </Modal>

        </div>
    );
};

export default Clientes;
